import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import GetHelp from "@/pages/GetHelp";
import Volunteer from "@/pages/Volunteer";
import Events from "@/pages/Events";
import Donate from "@/pages/Donate";
import Stories from "@/pages/Stories";
import Resources from "@/pages/Resources";
import Impact from "@/pages/Impact";
import News from "@/pages/News";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:slug" element={<Programs />} />
            <Route path="/get-help" element={<GetHelp />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/events" element={<Events />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        richColors
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: 'Nunito, sans-serif',
            background: '#FDFBF7',
            color: '#2C2621',
            border: '1px solid rgba(143,110,77,0.2)',
          },
        }}
      />
    </div>
  );
}

export default App;
